"use client"

import styled from "styled-components"
import {
  Badge,
  Card,
  CardHeader,
  Marker,
  Scale,
  StatGrid,
  StatLabel,
  StatText,
  StatValue,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

// Scale: 0 = D (junk), 100 = AAA (prime). Current = A+ ~ 80
const grades = ["D", "CCC", "B", "BB", "BBB", "A", "AA", "AAA"]
const current = 80

const ScaleTrack = styled.div`
  position: relative;
  margin: 2rem 0 0.5rem;
`

const GradientScale = styled.div`
  height: 0.5rem;
  width: 100%;
  border-radius: 9999px;
  background: linear-gradient(
    to right,
    var(--color-alert),
    var(--color-caution),
    var(--color-optimal)
  );
`

export function CreditRatingCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Credit rating</Title>
          <Subtitle>S&amp;P long-term issuer</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">Stable outlook</Badge>
      </CardHeader>

      <ScaleTrack>
        <GradientScale />
        <Marker percent={current} color="var(--color-optimal)" />
      </ScaleTrack>
      <Scale>
        {grades.map((g) => (
          <span key={g}>{g}</span>
        ))}
      </Scale>

      <StatGrid>
        <div>
          <StatLabel>Rating</StatLabel>
          <StatValue $tone="optimal">A+</StatValue>
        </div>
        <div>
          <StatLabel>Last action</StatLabel>
          <StatText>Upgrade</StatText>
        </div>
        <div>
          <StatLabel>5Y CDS</StatLabel>
          <StatValue>42 bps</StatValue>
        </div>
      </StatGrid>
    </Card>
  )
}

export default CreditRatingCard
